export default {
  imgBaseUrl: 'https://longyi-1308972172.cos.ap-nanjing.myqcloud.com',
  baseURL: 'https://ngymob.sosozhaofang.com',
  // baseURL: 'http://192.168.188.113:9067',
  // baseURL: 'http://192.168.124.10:9067',
  SecretId: 'AKID3tUothFWXHkwsYx5wXrugCTUEivqUrxm',
  SecretKey: 'auykFUTBftue8LHwKRHr9BwRhgPs51g4',
  BucketName: 'longyi-1308972172'
}
